import { memo, useRef } from 'react'
import { Container, Text } from '@pixi/react'
import { Button, soundManager, t, useVoucherStore } from '@slot-nx/core'
import { Text as PixiText } from 'pixi.js'
import { playNowBtnTextStyle } from '../selectPopup/VoucherSelectPopupButtons'
import { GameStatus, useGameStore } from '../../../domain/game/store/GameStore'
import { VoucherSoundType } from '@slot-nx/core'
import { threecomboolympusMachine } from '../../../domain/machine/threecomboolympusMachine'

export const VoucherTotalWinButton = memo(() => {
  const continueTextRef = useRef<PixiText>()
  return (

    <Container name="VoucherTotalWinButton">
      <Button
        name="continue_btn"
        defaultView="play_now_normal"
        hoverView="play_now_hover"
        pressedView="play_now_click"
        disabledView="play_now_unable"
        enabled={true}
        x={-170.5}
        y={240}
        width={341}
        height={157}
        key="continue_btn"
        onPressing={() => {
          (continueTextRef.current as PixiText).position.y = 312
        }}
        onHoverEnd={() => {
          (continueTextRef.current as PixiText).position.y = 305
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          useGameStore.setState({ gameStatus: GameStatus.Normal })
          useVoucherStore.setState({ isShowVoucherTotalWinPopup: false })
          threecomboolympusMachine.send({ type: 'check remain voucher' })
        }}
      />
      <Text
        text={t('voucher_total_win_popup_continue_btn')}
        x={0}
        y={305}
        anchor={[0.5, 0.5]}
        name="CONTINUE"
        style={playNowBtnTextStyle}
        ref={(el) => {
          continueTextRef.current = el as PixiText
        }}
      />

    </Container>

  )
})
